const pickSource = (item) =>
  item?.message_request ||
  item?.request_data ||
  item?.approval_payload ||
  item ||
  {};

export const getApprovalSendPayload = (item) => {
  const payload = item?.payload;
  if (payload && typeof payload === "object" && Object.keys(payload).length > 0) {
    return payload;
  }
  return null;
};

export const isCounselorScheduleMessage = (item) => {
  const payload = getApprovalSendPayload(item);
  if (payload) return Boolean(payload.schedule);
  const source = pickSource(item);
  return Boolean(source.schedule ?? item?.schedule);
};

export const buildRecruiterSendPayload = (item) => {
  const source = pickSource(item);
  const payload = {
    message_body: source.message_body || item?.message_body || "",
    is_all: source.is_all ?? item?.is_all ?? false,
    query: source.query || item?.query || [],
    event_type: source.event_type || item?.event_type || "recruiter_student",
  };

  if (source.is_international ?? item?.is_international) {
    payload.is_international = source.is_international ?? item?.is_international;
  }
  if (source.parent_ack != null || item?.parent_ack != null) {
    payload.parent_ack = source.parent_ack ?? item?.parent_ack;
  }
  if (source.attachment_url || item?.attachment_url) {
    payload.attachment_url = source.attachment_url || item?.attachment_url;
  }
  if (source.dst_id || item?.dst_id) {
    payload.dst_id = source.dst_id || item?.dst_id;
  }

  return payload;
};

export const buildCounselorSendPayload = (item) => {
  const source = pickSource(item);
  const isSchedule = Boolean(source.schedule ?? item?.schedule);
  const messageBody =
    source.message_body || source.body || source.message_text || item?.message_body || "";

  const payload = {
    answers: source.answers || [],
    school_id: source.school_id || item?.school_id,
    groups: source.groups ?? item?.groups ?? [],
    priority: source.priority || { value: "normal", text: "Normal" },
    all_students_of_the_school:
      source.all_students_of_the_school ?? item?.all_students_of_the_school ?? false,
    students_assigned_to_me:
      source.students_assigned_to_me ?? item?.students_assigned_to_me ?? true,
    schedule: isSchedule,
    event_type: source.event_type || item?.event_type || "counselor_student",
    need_ack_parents: source.need_ack_parents ?? item?.need_ack_parents ?? false,
  };

  if (isSchedule) {
    payload.message_text = source.message_text || messageBody;
    if (source.schedule_date || item?.schedule_date) {
      payload.schedule_date = source.schedule_date || item?.schedule_date;
    }
    if (source.schedule_time || item?.schedule_time) {
      payload.schedule_time = source.schedule_time || item?.schedule_time;
    }
    if (source.college_id || item?.college_id) {
      payload.college_id = source.college_id || item?.college_id;
    }
  } else {
    payload.body = source.body || messageBody;
  }

  if (source.attachment || item?.attachment) {
    payload.attachment = source.attachment || item?.attachment;
  }

  return payload;
};
